import { SweepCanvasNode, CanvasElementType } from '../canvas-types';

export const isNbNode = (node?: SweepCanvasNode) =>
  node?.type === CanvasElementType.NURTURING_BUCKET;
